import 'babel-polyfill';
import React, { Component } from 'react';
//import { Router, Route, Switch, Redirect } from 'react-router';
import {
    BrowserRouter,
    Route,
    Switch,
    withRouter
} from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { createBrowserHistory } from 'history';
import { AppStart } from 'views/AppStart';
import NewPassword from 'views/NewPassword';
import SetNewPassword from 'views/SetNewPassword';
import ChangePassword from 'views/ChangePassword';
import ChangeSumo from 'views/ChangeSumo';
import ChangeService from 'views/ChangeService';
import Overview from 'views/Overview';
import ChangeSubscription from 'views/ChangeSubscription';
import PostpaidTopup from 'views/PostpaidTopup';
import PrepaidTopup from 'views/PrepaidTopup';
import ChangeAddress from 'views/ChangeAddress';
import ChangeUserAddress from 'views/ChangeUserAddress';
import OrderSimcard from 'views/OrderSimcard';
import ActivateSimcard from 'views/ActivateSimcard';
import Blocking from 'views/Blocking';
import ReactGA from 'react-ga';
import "assets/scss/material-dashboard-pro-react.css?v=1.2.1";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from "@material-ui/core/CssBaseline";
import { SnackbarProvider } from 'notistack';
import "./styles.css";
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const history = createBrowserHistory();
var instKey;
var analyticsKey;
var reactPlugin = new ReactPlugin();

if (window.location.hostname.includes("sesprint")) { //Sprint Sweden
    instKey = 'db30de88-772b-4eeb-a726-db153c6a3cf5';
    analyticsKey = 'UA-121924115-9';
} else if (window.location.hostname.includes("sprint")) { //Sprint Norway
    instKey = 'd5f7672a-771a-4348-87c0-d31bd8b4c7b1';
    analyticsKey = 'UA-121924115-4';
} else if (window.location.hostname.includes("sedev")) { //Dev Sweden
    instKey = '7765a4c2-30a2-40fb-ac89-1f5393b591ec';
    analyticsKey = 'UA-121924115-7';
} else if (window.location.hostname.includes("dev") || window.location.hostname.includes("localhost")) { //Dev norway and localhost
    instKey = '314beb69-3980-4c4c-bf38-45ade7c7fc43';
    analyticsKey = 'UA-121924115-1';
} else if (window.location.hostname.includes("se-test")) { //Test Sweden
    instKey = 'eacd6062-f7ef-450d-9811-4cf1219c9e3d';
    analyticsKey = 'UA-121924115-8';
} else if (window.location.hostname.includes("test")) { //Test Norway
    instKey = '8c018a25-7e81-41f2-9f92-c30248edb6ca';
    analyticsKey = 'UA-121924115-2';
} else if (window.location.hostname.includes("mittchili")) { //Prod Sweden
    instKey = 'eacd6062-f7ef-450d-9811-4cf1219c9e3d';
    analyticsKey = 'UA-121924115-6';
} else { //Prod Norway
    instKey = "0a2b015d-c0a7-40f5-9d3e-6c8b998f218f";
    analyticsKey = 'UA-121924115-3';
}

ReactGA.initialize(analyticsKey);
const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: instKey,
        isCookieUseDisabled: true,
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history: history }
        }
    },
});
appInsights.loadAppInsights();
window.appInsights = appInsights;

history.listen((location, action) => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
});

const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    palette: {
        //primary: { main: purple[500] }, // Purple and green play nicely together.
        //secondary: { main: '#11cb5f' }, // This is just green.A700 as hex.
        error: { main: '#ff3763' },
        background: {
            default: "#F6F6F6"
        },
    },
});

const AnimatedSwitch = withRouter(({ location }) => (
    <TransitionGroup>
        <CSSTransition key={location.key} classNames="slide-right" timeout={1000}>
            <Switch location={location}>
                <Route exact path='/' component={AppStart} />
                <Route path='/overview' component={Overview} />
                <Route path='/new-password' component={NewPassword} />
                <Route path='/set-new-password' component={SetNewPassword} />
                <Route path='/change-password' component={ChangePassword} />
                <Route path='/change-subscription' component={ChangeSubscription} />
                <Route path='/change-service' component={ChangeService} />
                <Route path='/change-sumo' component={ChangeSumo} />
                <Route path='/add-subscription-quota' component={PostpaidTopup} />
                <Route path='/add-prepaid-quota' component={PrepaidTopup} />
                <Route path='/change-address' component={ChangeAddress} />
                <Route path='/change-user-address' component={ChangeUserAddress} />
                <Route path='/order-simcard' component={OrderSimcard} />
                <Route path='/activate-simcard' component={ActivateSimcard} />
                <Route path='/blocking' component={Blocking} />
            </Switch>
        </CSSTransition>
    </TransitionGroup>
));

export default class App extends Component {
    displayName = App.name;
    constructor(props) {
        super(props);
        this.state = {};
    }


    render() {
        return (
            <MuiThemeProvider theme={theme}>
                <SnackbarProvider maxSnack={3}>
                    <CssBaseline />
                        <BrowserRouter>
                            <AnimatedSwitch/>
                        </BrowserRouter>
                </SnackbarProvider>
            </MuiThemeProvider>
        );
    }
}


